import { useEffect } from 'react'
import { useSessionStorage } from 'react-use'
import { enableUpdates } from './updatesManager'
import { log } from 'utils/log'
import { trackEvent } from 'modules/analytics'
import { MINIMUM_HIDDEN_HOURS } from 'utils/hooks/useVisibilityTracker'

export const useForceAppRefresh = () => {
  const [hoursHidden, setHoursHidden] = useSessionStorage<number>('hoursHidden')

  useEffect(() => {
    enableUpdates({
      onForceRefreshed: () => {
        log('Sketch Cloud was updated to the latest version')
        if (hoursHidden >= MINIMUM_HIDDEN_HOURS) {
          trackEvent('App Force Refresh', { hoursHidden })
          setHoursHidden(0)
        }
      },
    })
  })
}
